import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Unreal_Engine_Development from "../../../assets/Services/Arcade_dev/Unreal_Engine_Development.png";
import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";
import Casino_Game_Development from "../../../assets/Services/Board_game_Dev/Casino_Game_Development.png";

import Audio_ from "../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Audio_&_Sound.svg";
import Concept_ from "../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Concept_&_Validation.svg";
import Marketing_ from "../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Marketing_&_Launch.svg";
import Story_ from "../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Story_&_World-Building.svg";
import Systems_ from "../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Systems_&_Backend.svg";
  
import Advanced_Avatar_ from '../../../assets/Services/Blockchain_game_dev/Blockchain_features/Advanced_Avatar_&_Character_Framework.svg'
import Chain_Asset_Ownership from '../../../assets/Services/Blockchain_game_dev/Blockchain_features/On-Chain_Asset_Ownership.svg'
import Launch_Support_ from '../../../assets/Services/Blockchain_game_dev/Blockchain_features/Post-Launch_Support_&_Maintenance.svg'
import Robust_NFT_Marketplaces from '../../../assets/Services/Blockchain_game_dev/Blockchain_features/Robust_NFT_Marketplaces.svg'
import UX_Engineering_for_Web3 from '../../../assets/Services/Blockchain_game_dev/Blockchain_features/UX_Engineering_for_Web3.svg'

import Mask_group from '../../../assets/Services/Blockchain_game_dev/Client/Mask_group.png'
import Mask_group2 from '../../../assets/Services/Blockchain_game_dev/Client/Mask_group2.png'
import Mask_group3 from '../../../assets/Services/Blockchain_game_dev/Client/Mask_group3.png'

import Core_Blockchain_Engineering from '../../../assets/Services/Blockchain_game_dev/Process/Core_Blockchain_Engineering.svg'
import InnovativeGame_Design_ from '../../../assets/Services/Blockchain_game_dev/Process/InnovativeGame_Design_&_Economic_Strategy.svg'
import Rigorous_Quality_Assurance from '../../../assets/Services/Blockchain_game_dev/Process/Rigorous_Quality_Assurance.svg'
import Seamless_Launch_ from '../../../assets/Services/Blockchain_game_dev/Process/Seamless_Launch_&_Ongoing_Support.svg'
import Strategic_Foundation_ from '../../../assets/Services/Blockchain_game_dev/Process/Strategic_Foundation_&_Roadmap.svg'

import Built_in_secure from '../../../assets/Services/Blockchain_game_dev/Blockchain_cards/Built_in_secure.png'
import Dynamic_gameplay from '../../../assets/Services/Blockchain_game_dev/Blockchain_cards/Dynamic_gameplay.png'
import Seamless_cross_platform from '../../../assets/Services/Blockchain_game_dev/Blockchain_cards/Seamless_cross_platform.png'
import Seamless_cross_platforms from '../../../assets/Services/Blockchain_game_dev/Blockchain_cards/Seamless_cross_platforms.png'

import big from '../../../assets/Services/Game_page/Blockchain/big.png'
import icon from '../../../assets/Services/Game_page/Blockchain/one.png'
import icon2 from '../../../assets/Services/Game_page/Blockchain/two.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";
const BlockChainGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Dynamic Gameplay    ",
      desc: "Our games combine play-to-earn mechanics with real, skill-based challenges. Forget mindless grinding—you’ll stay engaged, challenged, and, yeah, you can earn some crypto along the way.    ",
      img: Dynamic_gameplay,
    },
    {
      title: " Seamless Cross-Platform Play   ",
      desc: "  Whether you’re on your phone, tablet, or console, your progress and gear move with you. No disappearing items. No weird syncing issues. Just pure gaming, wherever you are.  ",
      img: Seamless_cross_platform,
    },
    {
      title: "  Next-Gen Digital Assets   ",
      desc: "  In-game items aren’t just collectibles—they evolve. Watch your gear gain rarity, value, and new abilities as you play. That basic sword you started with? It could turn into a legend. ",
      img: Seamless_cross_platforms,
    },
    {
      title: "Built-In Secure Marketplaces    ",
      desc: "  Tired of shady third-party trading? We’ve got you covered. Buy, sell, and trade your digital assets directly in-game with total security and transparency.  ",
      img: Built_in_secure,
    },
   
  ];

  const pokerdevcompany = [
    {
      title: "  Concept & Validation",
      icon: Concept_,
      desc: "   Every project starts with a spark. We brainstorm creative ideas, test their market potential, and shape a clear vision to guide the team from day one.  ",
    },
    {
      title: "Story & World-Building ",
      icon: Story_,
      desc: " Next, we build the heart of the game: its world and story. Our writers develop rich lore, unique characters, and a narrative that draws players into something memorable.    ",
    },
    {
      title: "  Systems & Backend",
      icon: Systems_,
      desc: " Behind every great game is solid tech. Our engineers design reliable servers, smooth multiplayer systems, and robust data management—so everything just works.    ",
    },
    {
      title: " Audio & Sound ",
      icon: Audio_,
      desc: " Sound matters. Our audio team crafts original music and immersive effects, creating an atmosphere that brings every moment to life.    ",
    },
    {
      title: "  Marketing & Launch",
      icon: Marketing_,
      desc: " Finally, we make sure your game gets noticed. From strategic marketing plans to eye-catching promos, we handle everything needed for a successful release.    ",
    },
  ];

  const pokerdevcompany2 = [
    {
      title: " Strategic Foundation & Roadmap  ",
      icon: Strategic_Foundation_,
      desc: "We start with a collaborative strategy session, diving into your vision and objectives. This isn’t just box-ticking—we’re focused on understanding your goals so we can build a tailored development roadmap. Every key milestone, every deliverable, laid out with transparency. The result? A clear path from concept to a secure, scalable game with integrated blockchain and native NFTs.     ",
    },

    {
      title: "Innovative Game Design & Economic Strategy  ",
      icon: InnovativeGame_Design_,
      desc: " Our design team brings sharp game mechanics and a thoughtful design philosophy to the table. We prioritize not just engaging gameplay, but also a robust, decentralized economic model. The aim? Maximize player retention and set the stage for sustainable, long-term revenue. Your game doesn’t just look good—it’s built to last.    ",
    },

    {
      title: " Core Blockchain Engineering ",
      icon: Core_Blockchain_Engineering,
      desc: " Our developers handle the technical heavy lifting, translating approved designs into a solid product. Every blockchain component—from NFTs to smart contract security—is woven into the architecture, ensuring your game is reliable, secure, and future-proof.    ",
    },

    {
      title: "Rigorous Quality Assurance  ",
      icon: Rigorous_Quality_Assurance,
      desc: " We don’t cut corners on testing. Every feature, every transaction, every device—thoroughly validated. We fine-tune performance, ensure blockchain integrity, and polish gameplay, so your product launches without a hitch and keeps players engaged.    ",
    },

    {
      title: " Seamless Launch & Ongoing Support ",
      icon:Seamless_Launch_ ,
      desc: "  We manage the launch process end-to-end, from deploying smart contracts to integrating with marketplaces. Post-launch, our team stays involved—delivering updates, providing support, and keeping your game competitive and secure. With us, you’re covered for the long haul.   ",
    },
  ];

  const gamedevservices = [
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Casino Game Development  ",
      icon: Casino_Game_Development,
      desc: " Deliver immersive casino classics—from slots to roulette and blackjack—integrated with secure wallets, tournament systems, live dealer support, and multilingual functionality, all within a compliance-ready framework. ",
      link: "/casino-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon: Rummy_Game_Development,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon:  Chain_Asset_Ownership,
      title: " On-Chain Asset Ownership  ",
      desc: " We implement decentralized asset management so players have verifiable, secure ownership of in-game assets. No more walled gardens—just smart contracts and transparent ledgers.   ",
    },
    {
      icon:  Advanced_Avatar_,
      title: "  Advanced Avatar & Character Framework ",
      desc: "Our systems enable detailed customization and persistent identity. We architect deep character creation modules, prioritizing extensibility and player immersion.    ",
    },
    {
      icon:  Robust_NFT_Marketplaces,
      title: " Robust NFT Marketplaces  ",
      desc: "We develop NFT marketplaces with seamless blockchain integration. Fast transactions, secure protocols, and a user-driven marketplace experience—without clunky, outdated interfaces.     ",
    },
    {
      icon: UX_Engineering_for_Web3 ,
      title: " UI/UX Engineering for Web3  ",
      desc: " We design and implement intuitive, frictionless interfaces that lower the barrier to entry for blockchain gaming. Expect clean navigation, responsive layouts, and workflows that make sense.   ",
    },
    {
      icon:  Launch_Support_,
      title: "   Post-Launch Support & Maintenance",
      desc: "Our support doesn’t end at deployment. We provide continuous updates, monitor security, and optimize performance to ensure sustained gameplay and system stability.    ",
    },
  ];

  const clientexp = [
    {
      icon: Mask_group3,
      name: "Alex Chen",

      desc: "We set out with some pretty bold goals—and, let’s be honest, blockchain isn’t exactly simple. This team didn’t just deliver our game; they became a real partner. They took our rough ideas, built a clear plan, and put together a sustainable token model. The final product went above and beyond what we pictured. Their ability to turn our “big vision” into a secure, working platform? That’s what made the difference for us.",
    },
    {
      icon:  Mask_group2,
      name: "Jack  ",
      undername: " ",
      desc: "What stood out most was their technical know-how. Security was non-negotiable for us, and their engineers went over every detail with a fine-tooth comb. The quality assurance process was thorough—nothing got overlooked. The end result? The game runs smoothly, and I have full confidence in the stability and security of our platform.",
    },
    {
      icon: Mask_group,
      name: "  Anya Sharma",
      undername: "  ",
      desc: "From day one, they understood what made our game unique. They took our play-to-earn ideas and made them both engaging and financially sound. NFT integration was handled seamlessly, and the player experience is exactly what we aimed for. These aren’t just developers—they’re talented game designers who understand our business goals. ",
    },
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              Blockchain Game Development
            </h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              At Raiden Labs, we build games powered by blockchain, where
              players actually own their digital items. We focus on security,
              transparency, and real player control—no middlemen, no nonsense.
              Our goal? To turn your ideas into unique gaming experiences, with
              fair economies and true asset ownership at the core. If you want a
              game where players matter most, that’s what we do.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
          <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={big} style={{ width: "85%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Blockchain Game Development: Powering the Next Digital Economies
            </h2>
            <p className="mt-4  h1-para">
              Raiden brings over ten years of real software experience to
              blockchain gaming. We turn your game ideas into secure,
              player-owned experiences—across PC, console, web, and mobile. Your
              vision, made real on the blockchain.
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Empower Players with Asset Ownership
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Fortify Game Security
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Unlock P2E Opportunities
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Ensure Multi-Platform Accessibility
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Craft Tailored Blockchain Solutions
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart  text-center">
        <h2 className="h2-heading lh-base ">
          Blockchain Gaming Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Ready for the future of gaming? So are we. At our core, we’re
          gamers—obsessed with building blockchain games that are secure,
          genuinely fun, and actually rewarding. We don’t just add buzzwords; we
          create experiences that keep players coming back for more (and not
          just for the loot).
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80 mart text-center bg-light pt-50 pb-50">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Blockchain Game Development
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            We engineer custom solutions from the ground up, tailored to your
            project’s unique requirements. Our builds aren’t just
            “playable”—they’re optimized for both user engagement and revenue
            potential.{" "}
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart mart ">
        <div className="container p-4">
          <div className="row align-items-center   ">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Unite with us for bespoke hall software engineered for high
                performance, scalability, and a stimulating player experience.
                From conception and character design to multiplayer armature and
                live deployment, we deliver the complete technology stack so you
                can launch, contend, and dominate in any request.{" "}
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
                  TALK WITH OUR EXPERTS NOW!
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon} alt=""  className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Blockchain
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge Blockchain gameplay 
            experience.
          </p>
          <CoreComponent32 />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Blockchain Game Development: Seamless Across
              Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37 />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart mart ">
        <div className="container p-4">
          <div className="row align-items-center   flex-column-reverse  flex-lg-row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart  text-center">
        <h2 className="h2-heading lh-base mb-3">
          Our BlockChain Game Development Process
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Building a captivating world and story while engineering the
          underlying technology, turning an initial concept into a finished
          product, and completing the experience with extensive audio and a
          well-thought-out launch strategy are the main goals of our process.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart  text-center ">
        <h2 className="h2-heading lh-base ">Our Other Game Developments</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We deliver a broad spectrum of game development services, leveraging
          advanced tools and technologies to build robust gaming experiences
          across multiple platforms and genres.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="text-center lh-base h2-heading ">
          Experience Raiden’s Blockchain Game Development
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We translate complex blockchain concepts and intricate tokenomics into
          a clear, strategic framework for your game. Our comprehensive
          understanding of the decentralized gaming industry allows us to create
          dependable solutions, ensuring a robust and effective platform that
          delivers a seamless experience and a sustainable in-game economy.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany2} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Hear directly from those who've partnered with us. These testimonials
          reflect Raiden Labs' commitment to excellence, innovation, and client
          satisfaction in Blockchain game creation.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
{/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt ">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlockChainGameDev;
